import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { publishChainStoreContract } from '../../api/chain-store-contract.ts';
import type { PublishChainStoreContractRequest } from '../../api/requests/chain-store-contract-request.ts';

export default function usePublishChainStoreContract(): UseMutationResult<
  string,
  Error,
  PublishChainStoreContractRequest
> {
  return useMutation({
    mutationFn: publishChainStoreContract,
  });
}
